
    import '/Users/lijixiang/Work/power-design/site/docs/flow-components/data-log.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-data-log-demo-data-log","docs-flow-components-data-log-demo-real"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/data-log.md?type=demo')
};